<template>
  <el-select
    v-model="unitModel"
    @change="unitChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.UNIT_OF_MEASURE')"
    :filterable="filterable"
    :disabled="disabled"
    remote
    :remote-method="getUnits"
    :loading="loading"
  >
    <el-option
      v-if="showAll"
      :value="null"
      :label="$t('COMMON.ALL_UNIT_OF_MEASURES')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="unit in units"
      :key="unit.id"
      :value="unit.id"
      :label="`${unit.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "unit-of-measure-unit-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    unit: {
      type: String,
      default: null,
      description: "Unit id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterUnitOfMeasure: {
      type: String,
      default: null,
      description: "Unit of measure id",
    },
  },

  data() {
    return {
      unitModel: this.unit ?? null,
      units: {},
    };
  },

  setup() {},

  created() {
    this.getUnits();
  },

  methods: {
    async getUnits(query = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { search: query } : {}),
          },
          page: {
            number: 1,
            size: 999999,
          },
        };
        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterUnitOfMeasure) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              unitOfMeasure: this.filterUnitOfMeasure,
            },
          };
        }

        await this.$store.dispatch("unitOfMeasureUnits/list", params);
        const unitsArr = await this.$store.getters["unitOfMeasureUnits/list"];
        this.units = {};
        unitsArr.forEach((unit) => {
          this.units[unit.id] = unit;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    unitChanged(id) {
      this.$emit("unitChanged", this.units[id]);
    },
  },

  watch: {
    unit(unit) {
      this.unitModel = unit;
      this.getUnits();
    },
    filterOrganization(filterOrganization) {
      this.getUnits();
    },
    filterUnitOfMeasure(filterUnitOfMeasure) {
      this.getUnits();
    },
  },
};
</script>
